import { CapoPlugin } from "/builds/webcontact/bad-peterstal-griesbach/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];